export interface PlacementCard {
  key: 'aks_cluster' | 'resource_group'
  label: string
  value: string
}

/**
 * Where a deployment runs, for the cards at the top of its detail page. A cluster deployment (a Helm application) names its AKS cluster. A
 * deployment that builds servers (Traverse, Ross, Apprise) has no cluster: the backend sends none for it, and it names the resource group the
 * servers are built in instead. Nothing is shown for what is not known, and never both.
 */
export function placementCards(deployment: { aks_cluster?: string; resource_group?: string }): PlacementCard[] {
  if (deployment.aks_cluster) return [{ key: 'aks_cluster', label: 'AKS Cluster', value: deployment.aks_cluster }]
  if (deployment.resource_group) return [{ key: 'resource_group', label: 'Resource Group', value: deployment.resource_group }]
  return []
}
